import { RadioGroup, RadioGroupItem } from "../../primitive/radio-group";

import { Label } from "../label";
import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface RadioGroupItemOption {
  value: string;
  label: string;
}

interface FormRadioGroupProps {
  items: RadioGroupItemOption[];
  showErrorMessage?: boolean;
  className?: string;
  orientation?: "horizontal" | "vertical";
}

function FormRadioGroup({
  items,
  showErrorMessage = true,
  className,
  orientation = "vertical",
}: FormRadioGroupProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <RadioGroup
        value={field.state.value ?? ""}
        onValueChange={(value) => field.handleChange(value)}
        className={className}
        orientation={orientation}
      >
        {items.map((item) => (
          <div key={item.value} className="flex items-center gap-2">
            <RadioGroupItem
              value={item.value}
              id={`${field.name}-${item.value}`}
            />
            <Label
              htmlFor={`${field.name}-${item.value}`}
              className="cursor-pointer"
            >
              {item.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormRadioGroup };
export type { RadioGroupItemOption as RadioGroupItem };
